export default class LogoVersionRequest {
  /** @type {string=} */
  id;
  /** @type {string=} */
  thumbUrl;
  /** @type {number} */
  status;
  /** @type {string} */
  logoVersionId;
  /** @type {string} */
  brandId;
  constructor(/** @type {Partial<LogoVersionRequest>} */ initialState) {
    Object.assign(this, initialState);
  }
}



// WEBPACK FOOTER //
// ./src/models/LogoVersionRequest.js